import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip } from 'antd'
import ProcessingTime from "../../../shared/ProcessingTime"

class BatchMerge extends Component {
    render() {
        const { location, onActionSendMerge, loading, disabled, className, isReady, processingAt, errorMessage, onHovering, hovering, mergeFileStatus } = this.props
        const isSW = !!location && location === "SW"

        return (
            (mergeFileStatus === "processing" && (!!processingAt || !!errorMessage)) ?
                <Tooltip
                    placement='topLeft'
                    title={<ProcessingTime processingAt={processingAt} hovering={hovering} errorMessage={errorMessage} />}
                    onMouseEnter={() => onHovering(true)}
                    onMouseLeave={() => onHovering(false)}
                >
                    <Button icon="download"
                        type={"primary"}
                        disabled={loading || disabled}
                        className={`btn-download mr-3 mt-2 ${isReady === false ? className : ''} ${disabled ? 'btn-download-disabled' : ''}`}
                        onClick={() => onActionSendMerge(false, location)}
                        style={{
                            backgroundColor: isSW ? '#ff1818' : '#1890ff',
                            borderColor: isSW ? '#ff1818' : '#1890ff',
                        }}
                    >
                        {isSW ? "Đăng Quang" : "Download file in"}
                    </Button>
                </Tooltip> :
                <Button icon="download"
                    type={"primary"}
                    disabled={loading || disabled}
                    className={`btn-download mr-3 mt-2 ${isReady === false ? className : ''} ${disabled ? 'btn-download-disabled' : ''}`}
                    onClick={() => onActionSendMerge(false, location)}
                    style={{
                        backgroundColor: isSW ? '#ff1818' : '#1890ff',
                        borderColor: isSW ? '#ff1818' : '#1890ff',
                    }}
                >
                    {isSW ? "Đăng Quang" : "Download file in"}
                </Button>
        )
    }
}

BatchMerge.propTypes = {
    id: PropTypes.string
}

export default BatchMerge
